/**
 * @description 应用管理 appManager
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const appManagerBiz = new Logic()

appManagerBiz.findAppByGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.findAppByGroup,
    data: data
  })
}

appManagerBiz.findAllAppList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.findAllAppList,
    data: data
  })
}

appManagerBiz.findAllGroupList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.findAllGroupList,
    data: data
  })
}

appManagerBiz.findAllGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.findAllGroup,
    data: data
  })
}

appManagerBiz.findAppById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.findAppById,
    data: data
  })
}

appManagerBiz.findGroupById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.findGroupById,
    data: data
  })
}

appManagerBiz.updateApp = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.updateApp,
    data: data
  })
}

appManagerBiz.updateGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.updateGroup,
    data: data
  })
}

appManagerBiz.deleteApp = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.deleteApp,
    data: data
  })
}

appManagerBiz.deleteGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.deleteGroup,
    data: data
  })
}

appManagerBiz.saveApp = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.saveApp,
    data: data
  })
}

appManagerBiz.saveGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.saveGroup,
    data: data
  })
}

appManagerBiz.updateAppStatus = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.updateAppStatus,
    data: data
  })
}

appManagerBiz.updateGroupStatus = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.updateGroupStatus,
    data: data
  })
}

appManagerBiz.getAppStatus = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.getAppStatus,
    data: data
  })
}

appManagerBiz.getPinpoints = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.getPinpoints,
    data: data
  })
}

appManagerBiz.queryGroups = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.appManager.queryGroups,
    data: data
  })
}

export default appManagerBiz
